import { PropsWithChildren } from 'react';
import { List as MuiList, ListProps as MuiListProps } from '@mui/material';

export type ListProps = PropsWithChildren &
  MuiListProps & {
    flex?: boolean | string;
    layout?: 'row' | 'column';
    'layout-align'?: string;
    'layout-padding'?: boolean;
  };

export const List: React.FC<ListProps> = ({ children, flex, layout = 'row', ...boxProps }) => {
  const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, sx, ...props } = boxProps;
  const align = layoutAlign?.split(' ');
  const justifyContent = align?.[layout === 'row' ? 0 : 1];
  const alignItems = align?.[layout === 'row' ? 1 : 0];

  return (
    <MuiList
      sx={{
        display: !!flex || layoutAlign ? 'flex' : undefined,
        flex: typeof flex === 'string' ? flex : undefined,
        justifyContent,
        alignItems,
        padding: layoutPadding ? '16px' : undefined,
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiList>
  );
};
